import { createAction, props } from '@ngrx/store';
import { NotebookResource, NotebookSidebarPreference, NotebookType } from '@mode/notebooks/contract';

export const createNotebook = createAction('[Notebook] Create Notebook', props<{ reportToken: string }>());

export const addNotebookResourcesOnSuccess = createAction(
  '[Notebook] Add Notebook Resources on success',
  props<{ notebookResource: NotebookResource }>()
);

export const addNotebookFailure = createAction('[Notebook] AddFailure', props<{ reportToken: string; error: Error }>());
export const updatePreference = createAction('UpdatePreference', props<{ params: NotebookSidebarPreference }>());

export const updateNotebookType = createAction(
  '[Notebook] Patch',
  props<{ notebookToken: string; notebookType: NotebookType }>()
);

export const run = createAction(
  '[Notebook] Run',
  props<{ notebookToken: string; runAllCells: boolean; cellTokensToRun: string[] }>()
);

export const cancelRun = createAction('[Notebook] CancelRun', props<{ notebookToken: string }>());

export const initSession = createAction(
  '[Notebook] InitSession',
  props<{
    notebookToken: string;
    reuseIfActive: boolean; // reuse an existing active session, if possible
    runNewCells?: boolean;
  }>()
);

export const clearAllCellOutputs = createAction(
  '[Notebook] Clear All Cell Outputs',
  props<{
    notebookToken: string;
  }>()
);

export const refreshSessionReportRun = createAction(
  '[Notebook] RefreshSessionReportRun',
  props<{
    notebookToken: string;
  }>()
);

export const initNotebook = createAction(
  '[Notebook] Init'
  // notebookToken: string; // TODO: Use token when UI supports multiple notebooks
);

export const toggleNotebookSidebar = createAction('ToggleNotebookSidebar');

//Old action names for reference
export const addNotebook = createAction('[Notebook] Add', props<{ reportToken: string }>());

export const terminated = createAction(
  '[[Notebook] Terminated',
  props<{ sessionToken: string; notebookToken: string; terminationReason: string }>()
);
